import React, { useState, useEffect, useContext } from 'react'
import { JsonForms } from '@jsonforms/react'
import { materialCells } from '@jsonforms/material-renderers'
import 'designer/styles/dynamic.css'
import { DesignContext } from 'contexts/DesignContext'
import objectPath from 'object-path'

const PanelEditor = (props) => {
  let { uischema, schema, renderers, panelUi } = props
  let { cardColor } = uischema

  const designContext = useContext(DesignContext)
  const { isUiChanged } = designContext
  const viewKey = objectPath.get(isUiChanged, [
    'viewListItem',
    uischema.dynamicKey,
    'viewKey',
  ])

  let { dynamicIndex, dynamicName, isDynamic, isArray, arrayName } =
    props?.config || {}

  const fieldKey = isArray
    ? `@${arrayName}.${uischema.key}`
    : isDynamic
    ? `${dynamicName}.${dynamicIndex}.${uischema.key}`
    : uischema.key

  const [render, setRender] = useState(false)

  useEffect(() => {
    if (render) {
      setRender(false)
    }
  }, [render])

  return (
    <>
      <div className="pt-2 pb-3 w-100 mx-auto">
        <div
          style={{
            width: '100%',
            border: `1px solid ${cardColor || 'transparent'}`,
            borderRadius: '4px',
          }}
        >
          <JsonForms
            schema={schema}
            uischema={panelUi}
            config={{
              dynamicId: `${fieldKey}-panel-${0}`,
              dynamicData: {},
              dynamicName: uischema.name,
              dynamicKey: uischema.key,
              dynamicIndex: 0,
              isFirstElement: true,
              isSample: false,
              viewKey: viewKey,
              dynamicConfig: props?.config,
            }}
            renderers={renderers}
            cells={materialCells}
          />
        </div>
      </div>
    </>
  )
}

export default PanelEditor
